import Api from 'libs/api';

class FiltersApi extends Api {
  constructor(page) {
    super(`${page ? page + '/' : ''}filters/`);
  }
}

export default FiltersApi;
